<script setup lang="ts">
import { ref } from "vue";
import { useUserProfileStore } from "@/store/UserProfile";
import Config from "@/config/Config";
import AppButton from "@/components/AppButton.vue";

const { requestInformation } = useUserProfileStore();

const showConfirmation = ref(false);
const privacyPolicyUrl = ref(Config.links.privacyPolicy);
const signUp = () => {
    requestInformation();
    showConfirmation.value = true;
};
</script>

<template>
    <div class="border-t border-[#2F4858] fixed bottom-0 left-0 w-full bg-[#f8f9fa] shadow-md py-2.5 text-center z-[1000]">
        <div class="max-w-[1200px] mx-auto flex justify-center items-center" @click="signUp">
            <img class="ml-5 w-[50px] align-middle" src="@/assets/logo.png" alt="Event logo image" />
            <div class="font-semibold mx-2 text-center flex-grow">
                <!-- Your ad content goes here -->
                <p class="text-center">Click Here to get information on</p>
                <p class="text-center">hosting your own Poker Run.</p>
            </div>
        </div>
        <div class="flex justify-center">
            <div v-if="showConfirmation" class="rounded shadow-lg m-4 p-0 max-w-md" role="alert">
                <div class="w-full text-center text-2xl bg-action text-white py-2">
                    Confirmation
                </div>
                <div class="p-2">

                    <div class="m-2 pb-2 text-center">
                        Please confirm you would like Aces Poker Run app to contact you with more information about
                        using
                        our solution for a future event.
                    </div>
                    <div class="flex justify-center p-2 gap-4">
                        <AppButton
                            title="Accept"
                            buttonType="Primary"
                            @click="signUp(); showConfirmation = false"
                        />
                        <AppButton
                            title="Decline"
                            buttonType="Secondary"
                            @click="showConfirmation = false"
                        />
                    </div>
                    <div class="flex justify-center p-2">
                        <a class="underline text-action" :href="privacyPolicyUrl" target="_blank">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

